import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  ChevronUp,
  Box,
  FileText,
  Filter,
  PlusCircle,
  RotateCcw,
  Sliders,
  List,
  User,
  Calendar,
} from "feather-icons-react/build/IconComponents";
import Select from "react-select";
import { Table } from "antd";
import { setheadertoggle } from "../../../../redux/toggle";
import { useDispatch, useSelector } from "react-redux";
import { getstockvalue } from "../../../../services/ReportApiService";
import {
  DatatablePagingParameter,
  Filterclass,
} from "../../../../core/json/DatatablePagingParameters";
import { renderTooltip } from "../../../../redux/helper";
import { Checkbox } from "antd";
import { DatePicker } from "antd";
// import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import {
  fetchCategory,
  fetchCounter,
  fetchProduct,
  fetchSection,
  fetchType,
  fetchSettings,
} from "../../../../redux/userSetting";
import {
  exportExcel,
  exportPDF,
  printReport,
} from "../../../../core/utils/StockReportUtils";
import LoadingUtils from "../../../../core/utils/LoadingUtils";

const StockValueReport = () => {
  const [searchText, setSearchText] = useState("");
  const [stockData, setstockData] = useState();
  const [Productfilter, setProductfilter] = useState();
  const [CategoryFilter, setCategoryFilter] = useState();
  const [TypeFilter, setTypeFilter] = useState();
  const [sectionval, setsectionval] = useState();
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [loading, setloading] = useState(false);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState(dayjs());
  const [totalcount, settotalcount] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const title = "Stock Value Reports";
  const dispatch = useDispatch();
  const { branch } = useSelector((state) => state.branchlist);
  const { togglehead } = useSelector((state) => state.headerToggle);
  const [decimalpoints, setDecimalPoints] = useState(2);
  const { counterList, sectionList,settingList,financialyear } = useSelector(
    (state) => state.usersetting
  );
  const { formatedproductList, formattedCategoryList, formattedTypeList } =
    useSelector((state) => state.usersetting);
  const { UserList } = useSelector((state) => state.userservice);
  const tableRef = useRef(null);

  useEffect(() => {
   // handleStockInReport(currentPage, pageSize);
    dispatch(fetchCategory(branch.guid));
    dispatch(fetchType());
    dispatch(fetchProduct(branch));
    dispatch(fetchSettings(branch));
        const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
        const currfmt = match ? match[0]?.length - 1 : 0;
        setDecimalPoints(currfmt);
  }, [branch]);

useEffect(() => {
  if (branch && fromDate && toDate) {
    handleStockInReport(currentPage, pageSize);
  }
}, [branch, fromDate, toDate, currentPage, pageSize]);



  const handleStockInReport = async (page, size) => {
    setloading(true);
    const DatatablePagingParameters = new DatatablePagingParameter();
    DatatablePagingParameters.PageNumber = 1;
    DatatablePagingParameters.PageSize = -1;
    const formattedfromDate = dayjs(fromDate).format("YYYY-MM-DD");
    const formattedtoDate = dayjs(toDate).format("YYYY-MM-DD");
    const Filters = new Filterclass();
    Filters.Branch = branch;
    Filters.FromDate = formattedfromDate;
    Filters.ToDate = formattedtoDate;
    Filters.Productfilter = Productfilter?.value;
    Filters.CategoryFilter = CategoryFilter?.value;
    Filters.Counter = TypeFilter?.value;
    Filters.Section = sectionval?.value;
    try {
      const response = await getstockvalue({
        DatatablePagingParameters,
        Filters,
      });
      console.log(response?.data);
      setstockData(
        response?.data?.stockInReportDetail?.filter(
          (e) => e.branch.name == branch.name
        )
      );
      const totalCount = response?.data?.stockInReportDetail?.filter(
        (item) => item.branch.name === branch.name
      ).length || 0; // Fallback to 0 if undefined
      
      // Set the total count
      settotalcount(totalCount);
      setloading(false);
    } catch (error) {
      console.error(
        "Error Fetching Account Type!",
        error?.response?.data?.Message
      );
      setloading(false);
    }
  };
 

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

 
  const menuItems = [
    { value: "1", label: "Product", checked: true },
    { value: "2", label: "Category", checked: true },
    { value: "3", label: "Type", checked: true },
    { value: "4", label: "Stock In", checked: true },
    { value: "5", label: "Stock Out", checked: true },
   // { value: "6", label: "Total Purchase Stock", checked: true },
    { value: "7", label: "Current Stock", checked: true },
    { value: "8", label: "Avg. Cost", checked: true },
    { value: "9", label: "Stock Value", checked: true },
  ];

  const columns = [
    {
      title: "Product",
      key: "1",
      dataIndex: "product",
      render: (text) => <span>{text.name}</span>,
    },
    {
      title: "Category",
      key: "2", // Updated key
      dataIndex: "category",
      render: (text) => <span>{text.name}</span>,
    },
    {
      title: "Type",
      key: "3", // Updated key
      dataIndex: "type",
      render: (text) => <span>{text.name}</span>,
    },
    {
      title: "Stock In",
      key: "4", // Updated key
      dataIndex: "totalStockIN",
    },
    {
      title: "Stock Out",
      key: "5", // Updated key
      dataIndex: "totalStockOut",
    },
    {
      title: "Total Purchase cost",
      key: "6", // Updated key
      dataIndex: "totalPurCost",
    },
    {
      title: "Current Stock",
      key: "7", // Updated key
      dataIndex: "totalCurStock",
    },
    {
      title: "Avg. Cost",
      key: "8", // Updated key
      dataIndex: "wAvrgCost",
      render: (value) => (<span>{Number(value).toFixed(decimalpoints)}</span> ),
    },
    {
        title: "Stock Value",
        key: "9", // Updated key
        dataIndex: "stockvalue",
        render: (_, record) => (
        <span>
          {(record.wAvrgCost * record.totalCurStock).toFixed(decimalpoints)}
        </span>
        ),
      },
  ];
  

  const [selectedColumns, setSelectedColumns] = useState();

  useEffect(() => {
    // Set default selected columns based on menuItems' checked status
    const initialSelectedColumns = menuItems
      ?.filter((item) => item.checked)
      .map((item) => columns.find((col) => col.key === item.value));

    setSelectedColumns(initialSelectedColumns);
  }, []);

  const handleCheckboxChange = (columnKey, checked) => {
    if (checked) {
      // Add column if checkbox is checked
      setSelectedColumns((prevColumns) => {
        const updatedColumns = [
          ...prevColumns,
          columns.find((col) => col.key === columnKey),
        ];

        // Sort the array by col.key in ascending order
        return updatedColumns.sort((a, b) => (a.key > b.key ? 1 : -1));
      });
    } else {
      // Remove column if checkbox is unchecked
      setSelectedColumns((prevColumns) =>
        prevColumns?.filter((col) => col.key !== columnKey)
      );
    }
  };

  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };
  const handleFromDateChange = (date) => {
    console.log(date, "from date");
   // setFromDate(date);

    setToDate(null); // reset to date when from date changes
  };
    useEffect(() => {
    if (financialyear && financialyear.length > 0) {
      const startDate = new Date(financialyear[0].startDate); // convert to Date object if needed
      setFromDate(startDate);
    }
  }, [financialyear]);
  console.log(fromDate, "from date");

  const handleToDateChange = (date) => {
    setToDate(date);
    console.log(date, "to date");
  };
  const getActiveTabData = () => {
    let fieldMapping = {};

    // Function to create the field mapping between column titles and dataIndex values
    const createfieldMapping = (columns) => {
      const mappings = {};
      columns.forEach((col) => {
        mappings[col.title] = col.dataIndex; // Map title to dataIndex
      });
      return mappings;
    };

    // Generate the field mapping for the current columns
    fieldMapping = createfieldMapping(columns);

    console.log("fieldMapping of first table:", fieldMapping);
    console.log("stockData of  table:", stockData);

    // Return the filtered data, columns, and field mapping
    return { data: stockData, columns: selectedColumns,Rname:"Stock Value Report", fieldMapping };
  };

  const handleReset = () => {
   // setFromDate(null);
    setToDate(dayjs());
    setSearchText("");
    setProductfilter("");
    setCategoryFilter("");
    setTypeFilter("");
    setsectionval("");
    handleStockInReport(currentPage, pageSize);
  };

  const filteredData = stockData?.filter((obj) => {
    const searchMatch =
      obj.product.name?.toLowerCase().includes(searchText?.toLowerCase()) ||
      obj.category.name?.toLowerCase().includes(searchText?.toLowerCase()) ||
      obj.type.name?.toLowerCase().includes(searchText?.toLowerCase());

    const categoryMatch = CategoryFilter
      ? obj?.category?.name === CategoryFilter.label
      : true;
    const itemMatch = Productfilter
      ? obj?.product?.name === Productfilter.label
      : true;
    const typeMatch = TypeFilter ? obj?.type?.name === TypeFilter.label : true;
    return searchMatch && categoryMatch && itemMatch && typeMatch;
  });
 
  const stockvalue = filteredData?.reduce(
    (sum, record) => sum + (record.wAvrgCost * record.totalCurStock),
    0
  );
  const footerTotals = {

    stockvalue: stockvalue?.toFixed(decimalpoints) || 0,
    totalStockIN: filteredData?.reduce((sum, record) => sum + record.totalStockIN,0)?.toFixed(decimalpoints) || 0,
    totalStockOut: filteredData?.reduce((sum, record) => sum + record.totalStockOut,0)?.toFixed(decimalpoints) || 0,
    totalPurCost: filteredData?.reduce((sum, record) => sum + record.totalPurCost,0)?.toFixed(decimalpoints) || 0,
    totalCurStock: filteredData?.reduce((sum, record) => sum + record.totalCurStock,0)?.toFixed(decimalpoints) || 0,
    wAvrgCost: filteredData?.reduce((sum, record) => sum + record.wAvrgCost,0)?.toFixed(decimalpoints) || 0,
  };
  return (
    <div>
      <LoadingUtils loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Stock Value Report</h4>
                <h6>Manage Stock Value Report here</h6>
              </div>
            </div>

            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                  <button
                    onClick={() => exportPDF(getActiveTabData, footerTotals, title)}
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Excel")}
                >
                  <button
                    onClick={() => exportExcel(getActiveTabData, footerTotals, title)}
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="excel-icon"
                    />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Print")}
                >
                  <button
                    onClick={() => printReport(getActiveTabData, footerTotals, title)}
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <i data-feather="printer" className="feather-printer" />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Collapse")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={togglehead ? "active" : ""}
                    onClick={handletogglehead}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top d-flex align-items-center flex-wrap gap-2">
  {/* Search Input */}
  <div className="search-input">
    <Link to="#" className="btn btn-searchset">
      
    </Link>
    <input
      type="search"
      className="form-control mb-2"
      placeholder="Search"
      aria-controls="DataTables_Table_0"
      value={searchText}
      onChange={(e) => setSearchText(e.target.value)}
    />
  </div>

  {/* From Date */}
  {/* <div className="input-blocks">
    <label>From Date</label>
    <div className="input-groupicon calender-input">
      <Calendar className="info-img" />
      <DatePicker
        className="datetimepicker"
        id="from-date"
        placeholderText="From Date"
        value={fromDate}
        onChange={handleFromDateChange}
        startDate={fromDate}
        selectsStart
        allowClear
      />
    </div>
  </div> */}

  {/* To Date */}
  {/* <div className="input-blocks">
    <label>To Date</label>
    <div className="input-groupicon calender-input">
      <Calendar className="info-img" />
      <DatePicker
        id="to-date"
        placeholderText="To Date"
        value={toDate}
        onChange={handleToDateChange}
        minDate={fromDate}
        selectsEnd
        allowClear
        // disabled={!fromDate}
      />
    </div>
  </div> */}
  <div className="input-blocks">
  <label>As On Date</label>
  <div className="input-groupicon calender-input">
    <Calendar className="info-img" />
    {/* <DatePicker
      id="to-date"
      placeholder="As On Date"
      value={toDate}
      onChange={handleToDateChange}
 disabledDate={(current) => {
  // If fromDate is not selected, allow all dates
  if (!fromDate) return false;

  // Otherwise, disable dates before fromDate
  return current.isBefore(fromDate, 'day');
}}
      allowClear
    /> */}
    <DatePicker
  id="to-date"
  placeholder="As On Date"
  value={toDate}
  onChange={handleToDateChange}
  allowClear
  disabled={!fromDate} // ⛔ disables if no From Date
  disabledDate={(current) => {
    if (!fromDate || !dayjs.isDayjs(fromDate)) return false;
    return current.isBefore(fromDate, "day");
  }}
/>

  </div>
</div>


  {/* Search Button */}
  <div className="input-blocks">
    <button
      className="btn btn-filters rounded-2"
      onClick={() => {
        setCurrentPage(1);
        setPageSize(20);
        handleStockInReport(1,20);
      }}
    >
      <i data-feather="search" className="feather-search" /> Search
    </button>
  </div>

  {/* Reset Button */}
  <div className="input-blocks" style={{marginLeft:"-50px"}}>
    <button className="btn btn-reset rounded-2" onClick={handleReset}>
      <i data-feather="refresh-cw" className="feather-refresh-cw" /> Reset
    </button>
  </div>

  {/* Filter Dropdown */}
  <div className="dropdown">
    <button
      className="btn dropdown-toggle"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <Sliders className="info-img" />
    </button>
    <ul className="dropdown-menu p-2">
      {menuItems
        ?.filter((menu) => menu.label !== "Product")
        .map((obj, i) => (
          <li key={i}>
            <Checkbox
              onChange={(e) => handleCheckboxChange(obj.value, e.target.checked)}
              defaultChecked={obj.checked}
            >
              {obj.label}
            </Checkbox>
          </li>
        ))}
    </ul>
  </div>
</div>


              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                 
                  <div className="row">
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <Box className="info-img" />
                        <Select
                          className="img-select"
                          options={formatedproductList}
                          value={Productfilter}
                          onChange={setProductfilter}
                          classNamePrefix="react-select"
                          placeholder="Product"
                          isClearable
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <FileText className="info-img" />
                        <Select
                          className="img-select"
                          options={formattedCategoryList}
                          value={CategoryFilter}
                          onChange={setCategoryFilter}
                          classNamePrefix="react-select"
                          placeholder="Category"
                          isClearable
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <List className="info-img" />
                        <Select
                          className="img-select"
                          options={formattedTypeList}
                          value={TypeFilter}
                          onChange={setTypeFilter}
                          classNamePrefix="react-select"
                          placeholder="Type"
                          isClearable
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Filter */}
              {selectedColumns && (
                <div className="table-responsive product-list">
                  <Table
                    columns={selectedColumns}
                    dataSource={filteredData}
                    ref={tableRef}
                    id="table-to-export"
                    className="table datanew dataTable no-footer custom-table"
                    pagination={{
                      showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${totalcount} items`,
                      current: currentPage,
                      pageSize: pageSize,
                      total: totalcount, // Total records count
                      onChange: (page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                        handleStockInReport(page, size);
                      },
                      showSizeChanger: true, // To enable page size selection dropdown
                      pageSizeOptions: ["10", "20", "50", "100"], // Different page size options
                    }}
                    summary={() => (
                      <Table.Summary.Row>
                      {selectedColumns?.map((col) => (
                        <Table.Summary.Cell key={col.dataIndex}>
                          <b>{footerTotals[col.dataIndex] || ""}</b>
                        </Table.Summary.Cell>
                      ))}
                    </Table.Summary.Row>
                    )}
                  />
                </div>
              )}
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
    </div>
  );
};
export default StockValueReport;

